<div class="interstitial-modal">
    <p>{{data.labels.description}}</p>
    <div class="actions">
        <finder-button theme="secondary" class="cancel-button" (click)="dismiss()">{{ data.labels.button.close }}</finder-button>
        <finder-button theme="primary" *ngIf="data?.href" [href]="data.href">{{ data.labels.button.continue }}</finder-button>
    </div>
</div>
